import { Component, Input, OnInit, inject } from '@angular/core';
import { ProviderOffice } from '../../../core/models/provider-office.model';
import { ProviderOfficeFilters, ProviderService } from '../../../core/services/provider.service';
import { MinimalProvider } from 'app/core/models/minimal-provider.model';
import { NgClass } from '@angular/common';
import { OfficeComponent } from '../office/office.component';

@Component({
    selector: 'app-prescriber-offices',
    templateUrl: './prescriber-offices.component.html',
    styleUrls: ['./prescriber-offices.component.scss'],
    imports: [NgClass, OfficeComponent]
})
export class PrescriberOfficesComponent implements OnInit {
  private providerService = inject(ProviderService);

  @Input() provider: MinimalProvider;
  @Input() acceptableFaxStatusOnly = false;
  @Input() scrollable = false;

  officesRefreshing = true;
  providerOffices: ProviderOffice[] = [];
  providerOfficeFaxStatuses = {};

  ngOnInit() {
    this.loadOffices();
  }

  loadOffices() {
    this.officesRefreshing = true;

    const filters = new ProviderOfficeFilters();
    filters.acceptableFaxStatusOnly = this.acceptableFaxStatusOnly;

    this.providerService
      .getProviderOffices(this.provider.id, filters)
      .subscribe((providerOffices: ProviderOffice[]) => {
        this.providerOffices = providerOffices;

        this.officesRefreshing = false;
      });
  }
}
